<template>
    <div>
        <!-- header -->
            <div class="background-title w-100 mt-5 mb-5">
                <h1 class="title">
                  INVENTORY HOME SALE
                </h1>
            </div>
            <b-container>
                <!-- STOREY TOWNS & DETACHED ADS -->
                <img src="/img/inventory-home-sale.png" alt="inventory home sale" class="home-img"/>
                <h1 class="img-text p-2">
                  30 to 120-Day Closing Available
                </h1>
                <div class="mb-4">
                <h1 class="info-header">
                    2 Storey Towns & Detached
                </h1>
                <h1 class="info-subheader">
                    Quick Closing Available
                </h1>
                <p class="info-text">
                    REACH OUT TO BOOK YOUR TOUR TODAY!
                </p>
                </div>
                <!-- STOREY TOWNHOMES & DETACHED HOMES -->
                <b-row>
                    <b-col class="col-6 sub-column">
                        <h1 class="info-header-2 pt-2">
                        2 STOREY TOWNHOMES
                    </h1>
                    <p class="info-text-2">
                        start from
                    </p>
                    <h1 class="info-header-2">
                        $629,900
                    </h1>
                    <p class="info-text-2">From 1,259 Sq. Ft.</p>
                   </b-col>
                   <b-col class="col-6">
                    <h1 class="info-header-2 pt-2">
                        DETACHED HOMES
                    </h1>
                    <p class="info-text-2">
                        start from
                    </p>
                    <h1 class="info-header-2">
                        $799,900
                    </h1>
                    <p class="info-text-2">From 1,531 Sq. Ft.</p>
                   </b-col>
                </b-row>
                <div class="videoSection mt-5 mb-5">
                    <b-col class="col-7">
                        <video
                            ref="mvpVideo"
                            autoplay
                            loop
                            muted
                            @canplay="playVideo"
                            class="w-100">
                        <source src="/video/MVP-Comm-Website-Update-031925-4.mp4" type="video/mp4" />
                        </video>
                    </b-col>
                    <b-col class="col-5">
                        <div class="video-info mb-4">
                            <p class="video-text mt-4">
                                CLICK HERE TO BROWSE
                                <br/>
                                ALL INVENTORY HOMES
                                <br/>
                                & BOOK YOUR TOUR TODAY
                            </p>
                            <a href="https://docs.google.com/forms/d/e/1FAIpQLScyt8aIUZ8HjS2Pph8n5C0DNPE3PAzgHwvMFlSqF7qaw2VSsg/viewform" class="btn btn-lg btn-inventory">VIEW INVENTORY HOMES</a>
                        </div>
                        <div class="video-info">
                            <h1 class="title-info">
                                FOR MORE INFO:
                            </h1>
                            <p class="text-info-2">
                                TEXT/CALL
                            </p>
                            <h1 class="phone-info">
                                289.677.1564
                            </h1>
                        </div>
                    </b-col>
                </div>
            </b-container>
    </div>
</template>

<script>

export default {
    data() {
        return {

        }
    },
    methods: {
        playVideo() {
      const video = this.$refs.mvpVideo;
  
      video.play().catch((error) => {
        console.log("Error trying to play the video", error)
      })
    },
    }
}

</script>

<style lang="scss">

.background-title {
    background-color:#FBB044;
}

.title {
  font-weight: bold;
  font-size: 80px;
  letter-spacing: 1px;
  text-align: center;
}

.home-img {
    width: 100%;
    height: 455px;

    @media screen and (max-width: 768px) {
        height: 200px;
    }
}

.img-text {
  font-weight: bold;
  font-size: 37px;
  letter-spacing: 1px;
  text-align: center;
  background-color: #29AAE1;
  color: #fff;
}

.info-header {
  font-weight: bold;
  font-size: 72px;
  letter-spacing: 1px;
  text-align: center;
  color: #29AAE1;
}

.info-subheader {
    font-weight: bold;
    font-size: 50px;
    letter-spacing: 1px;
    text-align: center;
    color: #F05B2D;
}

.info-text {
    font-size: 37px;
    letter-spacing: 1px;
    text-align: center;
    color: #000;
}

.info-header-2 {
    font-size: 50px;
    letter-spacing: 1px;
    text-align: center;
    color: #000;

    @media screen and (max-width: 768px) {
        font-size: 25px;
    }
}

.info-text-2 {
    font-weight: 100;
    font-size: 27px;
    letter-spacing: 1px;
    text-align: center;
    color: #000;
    margin: 0;
}

.sub-column {
  border-right: 3px solid #000;
  height: auto;
}

.info-subheader-2 {
    font-size: 27px;
    letter-spacing: 1px;
    text-align: center;
    color: #000;
}

.video-text {
    font-size: 27px;
    line-height: 35px;
    font-weight: 100;
    letter-spacing: 1px;
    text-align: center;
    color: #000;

    @media screen and (max-width: 768px) {
        font-size: 13px;
        line-height: 20px;
    }
}

.btn-inventory {
    color: #fff;
    background-color: #F05B2D;
    border-radius: 0;
    cursor: pointer;

    &:hover {
      background-color: white;
      color: #f9ae43;
      border: 2px solid #f9ae43;
    }

    @media screen and (max-width: 768px) {
      font-size: 1rem;
    }
    
}

.videoSection {
    display: flex;
    @media screen and (max-width: 430px) {
        flex-direction: column;
        align-items: center;
    }
}

.video-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    
}

.title-info {
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 1px;
    text-align: center;
    color: #000;
    margin: 0;

    @media screen and (max-width: 768px) {
        font-size: 16px;
    }
}

.text-info-2 {
    font-weight: 500;
    font-size: 20px;
    letter-spacing: 1px;
    text-align: center;
    color: #29AAE1;
    margin: 0;
    @media screen and (max-width: 768px) {
        font-size: 14px;
    }
}

.phone-info {
  font-weight: bold;
  font-size: 42px;
  letter-spacing: 1px;
  text-align: center;
  color: #29AAE1;

  @media screen and (max-width: 768px) {
        font-size: 25px;
    }
}


</style>